import { render, staticRenderFns } from "./toptab.vue?vue&type=template&id=1509ac8c&scoped=true"
import script from "./toptab.vue?vue&type=script&lang=js"
export * from "./toptab.vue?vue&type=script&lang=js"
import style0 from "./toptab.vue?vue&type=style&index=0&id=1509ac8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1509ac8c",
  null
  
)

export default component.exports